module.exports = __webpack_public_path__ + "static/media/fg-left-desk.311bda63.svg";